import { registerMsgHandler } from "userful-chronos-app-common-js/dist/message/messageRegistery";
import {
    RESPOND_EDGEAI_STATUS,
    RESPOND_EDGEAI_UPDATE,
} from "userful-chronos-app-common-js/dist/message/messageTypeDefinitions/eisenhower/eisenhowerMsgs";
import eisenhowerStore from "../eisenhowerStore";
import { eisenhowerActions } from "../eisenhowerSlice";
import { EnableEdgeAI } from "userful-chronos-app-common-js/dist/models/eisenhower/edgeSetup";

registerMsgHandler(RESPOND_EDGEAI_STATUS, (payload) => {
    console.debug("receive RESPOND_EDGEAI_STATUS");
    const data = JSON.parse(payload) as EnableEdgeAI;
    eisenhowerStore.dispatch(eisenhowerActions.setEnableEdgeAI(data));
});

registerMsgHandler(RESPOND_EDGEAI_UPDATE, (payload) => {
    console.debug("receive RESPOND_EDGEAI_UPDATE");
    const data = JSON.parse(payload) as EnableEdgeAI;
    eisenhowerStore.dispatch(eisenhowerActions.setEnableEdgeAI(data));
});
